import { FC } from 'react'
import { OutputData } from '@editorjs/editorjs'
import { useEditor } from '../../../hooks/useEditor.ts'
import { Label } from '@/components/ui/label.tsx'
import { Info } from '@/js/editor/components/general/Info.tsx'

type EditorProps = {
    label: string
    onChange: (data: OutputData) => void
    initialData?: OutputData
    readonly?: boolean
    id: string
}

export const Editor: FC<EditorProps> = ({ label, onChange, initialData, readonly = true, id }) => {
    useEditor({
        holder: `mm_editor_${id}`,
        readOnly: readonly,
        data: initialData,
        minHeight: 50,
        editorId: id,
        onChange: (api) => {
            void (async () => {
                const content = await api.saver.save()
                onChange(content)
            })()
        },
    })

    return (
        <div className="grid pb-3 w-full items-center gap-1.5">
            <div className={'relative flex flex-row gap-3 items-center'}>
                <Label htmlFor="content">{label}</Label>
                <Info
                    description={
                        'Eine ausführliche Beschreibung, die formatiert werden kann. Wird in der Menüleiste angezeigt.'
                    }
                />
            </div>
            <div className={'relative'}>
                <div
                    id={`mm_editor_${id}`}
                    className="z-3001 min-h-20 max-w-full w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-base ring-offset-white placeholder:text-slate-500 focus-within:outline-none focus-within:ring-1 focus-within:ring-slate-500 focus-within:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:border-slate-800 dark:bg-slate-950 dark:ring-offset-slate-950 dark:placeholder:text-slate-400 dark:focus-within:ring-slate-300"
                ></div>
            </div>
        </div>
    )
}
